import {
  DashboardOutlined,
  UsergroupAddOutlined,
  UserAddOutlined,
  AppstoreAddOutlined,
  ShopOutlined,
  DoubleRightOutlined,
  AuditOutlined
} from "@ant-design/icons";

const icons = {
  DashboardOutlined,
  UsergroupAddOutlined,
  UserAddOutlined,
  AppstoreAddOutlined,
  ShopOutlined,
  DoubleRightOutlined,
  AuditOutlined,
};
const admin = {
  id: "group-admin",
  title: "Administrator",
  type: "group",
  role: "super_admin",
  children: [
    {
      id: "admin-dashboard",
      title: "Manage Super Admin",
      type: "item",
      url: "/super_admin",
      icon: icons.UserAddOutlined,
      breadcrumbs: false,
    },
    {
      id: "admin-organtization",
      title: "Manage Organization",
      type: "item",
      url: "/super_admin/organization",
      icon: icons.DashboardOutlined,
      breadcrumbs: false,
    },
    {
      id: "admin--manage-customers",
      title: "Manage Customers",
      type: "item",
      url: "/super_admin/customer",
      icon: icons.DashboardOutlined,
      breadcrumbs: false,
    },
    {
      id: "admin--manage-marketplace",
      title: "Manage Market Place",
      type: "item",
      url: "/super_admin/manage-marketplace",
      icon: icons.ShopOutlined,
      breadcrumbs: false,
    },
    {
      id: "admin-addons",
      title: "Manage Add ons",
      type: "item",
      url: "/super_admin/add_ons",
      icon: icons.AppstoreAddOutlined,
      breadcrumbs: false,
    },
    {
      id: "admin-demo-request",
      title: "Manage Add-ons Request",
      type: "item",
      url: "/super_admin/demo-request",
      icon: icons.DoubleRightOutlined,
      breadcrumbs: false,
    },
    {
      id: "audit-log",
      title: "Audit Logs",
      type: "item",
      url: "/super_admin/audit-log",
      icon: icons.AuditOutlined,
      breadcrumbs: false,
    },
    {
      id: "roles-and-permissions",
      title: "Roles and Permissions",
      type: "item",
      url: "/super_admin/roles-permissions",
      icon: icons.AuditOutlined,
      breadcrumbs: false,
    },
  ],
};

export default admin;
